// extracted by mini-css-extract-plugin
var _1 = "v4M89";
export { _1 as "base" }
